import MultiSort from './MultiSort.component';

export default MultiSort;
